
import
{
  styled,
  Card,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";
import { colors } from "../../../options/colors";

export const Container = styled('div')(() => ({
  position: 'relative',
  display: 'flex',
  width: "100%",
}));

export const StyledCard = styled(Card)(({ theme, recommended }) => ({
  margin: "0 20px",
  background: "rgba(0, 0, 0, 0.4)",
  width: "100%",
  //  height: "41em",
  borderRadius: 5,
  display: "flex",
  flexDirection: "column",
  border: recommended ? `3px solid ${colors.primaryOrange}` : undefined,
  borderTopWidth: recommended ? 30 : undefined,
  [theme.breakpoints.down("sm")]: {
    height: "unset",
    margin: 0,
  },
}));

export const StyledCardActions = styled(CardActions)(() => ({
  padding: 0,
  margin: "auto 0 0",
  textAlign: "center",
}));

export const StyledCardContent = styled(CardContent)(() => ({
  padding: "1.4em 2em",
  display: "flex",
  flexDirection: "column",
  alignItems: "left",
}));

export const IconAvatarContainer = styled("div")(() => ({
  marginBottom: 25,
}));

export const FeatureLinesContainer = styled("div")(() => ({
  width: "100%",
}));
